import React from 'react';

import { makeStyles, useTheme } from '@material-ui/core';
import PropTypes from 'prop-types';

import SymbolLoading from '../../common/SymbolLoading';

const LOGO_W = 1920;
const LOGO_H = 263;
const WORD_X = 664;
const WORD_W = LOGO_W - WORD_X;
const WORD_H = 38;
const SCALE = WORD_H / LOGO_H;

const useStyles = makeStyles(theme => ({
  root: {
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    height: '100%',
    justifyContent: 'center',
    left: 0,
    padding: theme.spacing(3),
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: 2000,
  },
  wordmark: {
    width: WORD_W * SCALE,
    height: WORD_H,
    backgroundImage: props => `url(${props.logo})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: `${LOGO_W * SCALE}px ${LOGO_H * SCALE}px`,
    backgroundPosition: `${-WORD_X * SCALE}px 0`,
  },
}));

function SlashScreen({ finishing, onFinished }) {
  const theme = useTheme();
  const classes = useStyles({ logo: theme.assets?.logoHorizontal });

  return (
    <div className={classes.root}>
      <SymbolLoading size={180} finishing={finishing} onFinished={onFinished} />
      <div className={classes.wordmark} role="img" aria-label="Eskolare" />
    </div>
  );
}

SlashScreen.propTypes = {
  finishing: PropTypes.bool,
  onFinished: PropTypes.func,
};

export default SlashScreen;
